import { render, staticRenderFns } from "./CallcentreMember.vue?vue&type=template&id=35267f38&"
import script from "./CallcentreMember.vue?vue&type=script&lang=js&"
export * from "./CallcentreMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports